import {createViewConfig} from '@sail/engine';
import type {SelectFieldProps} from './SelectField';

export const SelectFieldConfig = createViewConfig({
  name: 'SelectField',
  props: {} as SelectFieldProps<unknown, boolean>,
  defaults: {
    defaultExpandedKeys: 'all',
    expandable: false,
    selectionMode: 'single',
    size: 'medium',
    selectionAllEnabled: true,
    clearable: false,
  },
});
